// extracted by mini-css-extract-plugin
module.exports = {"list":"_7a3fb80146--list--N_Bhk","link":"_7a3fb80146--link--wJaTY","link--sec":"_7a3fb80146--link--sec--LBwqz"};